import {useCallback} from 'react';

import {Box, Link, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {PaymentLinkBrands} from '@/app/main/paymentLink/components/PaymentLinkBrands/PaymentLinkBrands';
import {
  PAYMENT_LINK_IMAGES,
  PaymentLinkUtm,
} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {AppButton} from '@/app/shared-components/AppButton/AppButton';
import {AppButtonVariant} from '@/app/shared-components/AppButton/models/interfaces';
import {LINKS} from '@/constants/LinksConstants';
import {usePaymentLinkTrackers} from '@/dataSource/src/api/payment-link/trackers';

interface PaymentLinkPromoProps {
  utmMedium: string;
  utmCampaign: string;
}

export const PaymentLinkPromo = (props: PaymentLinkPromoProps) => {
  const {t} = useTranslation();
  const {trackSelectRequestMoneyJoinModak} = usePaymentLinkTrackers();

  const handleOpenLink = useCallback(() => {
    const newWindow = window.open(
      LINKS.MODAK_PAYMENT_LINK_GET_STARTED(
        props.utmMedium,
        props.utmCampaign,
        PaymentLinkUtm.CODE,
      ),
      '_blank',
    );
    trackSelectRequestMoneyJoinModak('payment_link_promo');
    if (newWindow) {
      newWindow.focus();
      newWindow.opener = null;
    }
  }, [props.utmCampaign, props.utmMedium, trackSelectRequestMoneyJoinModak]);
  return (
    <Box className="payment-link-promo">
      <Box className="payment-link-promotion-container">
        <Box className="payment-link-promotion-left">
          <Typography className="payment-link-promo-title">
            {t('payment_link.promo_title', {
              amount: PaymentLinkUtm.Amount,
              code: PaymentLinkUtm.CODE,
            })}
          </Typography>
          <Typography className="payment-link-promo-subtitle">
            {t('payment_link.promo_description')}
          </Typography>
          <Box className="payment-link-button-container">
            <AppButton
              removeStyles={true}
              onClick={handleOpenLink}
              label={t('payment_link.get_started')}
              variant={AppButtonVariant.onPrimary}
            />
          </Box>
        </Box>
        <Box className="payment-link-right-image">
          <img
            src={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_COMPOSITE.src}
            alt={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_COMPOSITE.alt}
            width={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_COMPOSITE.width}
            height={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_COMPOSITE.height}
          />
        </Box>
      </Box>
      <PaymentLinkBrands />
      <Box className="payment-link-promo-disclaimer">
        <Typography className="payment-link-promo-disclaimer-text">
          {t('payment_link.footer_promo.text')}
          <Link
            href={LINKS.CONSUMER_ACCOUNT_CARD_HOLDER_AGREEMENT}
            className="payment-link-promo-disclaimer-text-link"
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            color="inherit">
            {t('payment_link.footer_promo.link')}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
